import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../../services/auth.service';

export const supportTicketGuard: CanActivateFn = () => {
  return inject(AuthService).hasFeatureEnabled('enableSupportTicket');
};
